import script from "./UserManageView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManageView.vue?vue&type=script&setup=true&lang=js"

import "./UserManageView.vue?vue&type=style&index=0&id=6cf12124&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cf12124"]])

export default __exports__